import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  fill({ params: { value } }) {
    this.inputTarget.value = value
  }
}
